const state = {
    languages: [
        {
            title: 'English',
            code: 'en'
        },
        {
            title: 'Русский',
            code: 'ru'
        },
    ],
    active: {
        title: 'Русский',
        code: 'ru'
    },
    tags: {}
}

const mutations = {
    setTags(state, value) {
        state.tags = value
    }
}

export default {
    namespaced: true,
    state,
    mutations
}
